/**
 * Haptics are sound's shadow (STYLEGUIDE §9): a pulse fires only where a cue
 * fires, and only for the board's discrete events — never for chrome, and
 * never for per-step surge cues, which would buzz as a cluster. iOS Safari
 * has no vibration API, so this is quietly Android-only; the settings row
 * hides itself where the API is missing.
 */

/** Milliseconds, or a vibrate/pause/vibrate pattern like the double-buzz. */
export type BuzzPattern = number | number[];

/**
 * The pattern book, tiered like the mix: moves are a light tap, refusals
 * thump like their hum, and only the payoffs run longer than a beat.
 */
export const BUZZ = {
  build: 15,
  remove: 15,
  deny: 20,
  limit: [20, 60, 20],
  win: [30, 80, 40],
  perfect: [30, 80, 30, 80, 50],
} as const satisfies Record<string, BuzzPattern>;

let enabled = true;

export function hapticsSupported(): boolean {
  return typeof navigator !== 'undefined' && 'vibrate' in navigator;
}

export function hapticsOn(): boolean {
  return enabled;
}

export function setHaptics(on: boolean): void {
  enabled = on;
}

export function buzz(pattern: BuzzPattern): void {
  if (!enabled || !hapticsSupported()) return;
  try {
    navigator.vibrate(pattern);
  } catch {
    // A vibration the browser refuses is not worth an error.
  }
}
